
document.addEventListener('DOMContentLoaded', function () {
  new Swiper('.offer_block_swiper', {
    slidesPerView: 2,
    spaceBetween: 10,
    navigation: {
      nextEl: '.offer_block_main .swiper-nav-next',
      prevEl: '.offer_block_main .swiper-nav-prev',
    },
    pagination: false
  });
});

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".faq-question").forEach(function(btn){
    btn.addEventListener("click", function(){
      const item=this.parentElement;
      item.classList.toggle("active");
    });
  });
});